import { SUGGEST_TEMPLATE_FORM } from "common/constants";
import { isPPTAddin } from "js/config";
import AppController from "js/core/AppController";

import { getPricingPageUrl } from "./pricing";
import { trackActivity } from "./utilities";

export const openPricingPage = (analytics = null) => {
    const currentPlan = AppController.workspaceMetadata.plan.type;

    if (analytics) {
        if (!analytics.cta) {
            throw new Error("analytics.cta is required");
        }

        trackActivity("Upgrade", "ShowPricingPage", null, null, analytics);
    }

    // if the user is in the PPT addin, we need to show a dialog instead of opening a new tab
    if (isPPTAddin) {
        window.location = `/ppt-addin/choosePlan?hideBasic=true&emphasizePlan=pro&hasTakenTrial=${AppController.user.hasTakenTrial2}&hasTakenTeamTrial=${AppController.user.hasTakenTeamTrial2}`;
    } else {
        window.open(getPricingPageUrl(AppController.user.hasTakenTrial2, AppController.user.has("hasTakenTeamTrial2"), currentPlan), "_blank");
    }
};

export async function openTeamUpgrade(analytics = {}, callback) {
    analytics.plan = AppController.workspaceMetadata.plan.type;

    trackActivity("Upgrade", "ShowTeamPricingPage", null, null, analytics);

    // if the user is in the PPT addin, we need to show a dialog instead of opening a new tab
    if (isPPTAddin) {
        window.location = `/ppt-addin/choosePlan?hideBasic=true&emphasizePlan=team&hasTakenTrial=${AppController.user.hasTakenTrial2}&hasTakenTeamTrial=${AppController.user.hasTakenTeamTrial2}`;
    } else {
        window.open("/team-upgrade", "_blank");
    }
}

export const openSuggestTemplateForm = () => {
    window.open(SUGGEST_TEMPLATE_FORM, "_blank");
};
